/**
 * M25 Cards Links — mouse drag on the carousel track.
 * Follows the pointer 1:1 while pressed; CSS mandatory snap
 * settles to a card after release. Touch / pen keep native overflow.
 */
(function () {
  if (window.__cardsLinksDrag) return;
  window.__cardsLinksDrag = true;

  var DRAG_THRESHOLD = 6;

  function settleSnap(track) {
    if (typeof track.scrollTo !== 'function') return;
    var reduce =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({
      left: track.scrollLeft + 1,
      behavior: reduce ? 'auto' : 'smooth',
    });
  }

  function isOverflowing(track) {
    return track.scrollWidth > track.clientWidth + 1;
  }

  function resetScroll(track) {
    if (typeof track.scrollTo === 'function') {
      track.scrollTo({ left: 0, behavior: 'auto' });
    } else {
      track.scrollLeft = 0;
    }
  }

  function initCarousel(root) {
    if (!root || root.dataset.cardsLinksBound === 'true') return;
    if (!root.classList.contains('cards-links--carousel')) return;

    var track = root.querySelector('[data-cards-links-track]');
    if (!track) return;

    root.dataset.cardsLinksBound = 'true';

    var pointerId = null;
    var startX = 0;
    var startScroll = 0;
    var dragged = false;
    var suppressClick = false;

    function onPointerMove(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var dx = event.clientX - startX;
      if (!dragged) {
        if (Math.abs(dx) <= DRAG_THRESHOLD) return;
        dragged = true;
        track.classList.add('is-dragging');
        // Capture only after a real drag so a still press keeps pointerup
        // on in-card links and the following click can navigate.
        if (typeof track.setPointerCapture === 'function') {
          track.setPointerCapture(pointerId);
        }
      }
      track.scrollLeft = startScroll - dx;
    }

    function endDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;
      var wasDragged = dragged;
      if (
        typeof track.hasPointerCapture === 'function' &&
        track.hasPointerCapture(pointerId)
      ) {
        track.releasePointerCapture(pointerId);
      }
      pointerId = null;
      dragged = false;
      track.classList.remove('is-dragging');
      if (wasDragged) {
        suppressClick = true;
        window.setTimeout(function () {
          suppressClick = false;
        }, 0);
        settleSnap(track);
      }
      track.removeEventListener('pointermove', onPointerMove);
      track.removeEventListener('pointerup', endDrag);
      track.removeEventListener('pointercancel', endDrag);
    }

    track.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;
      if (!isOverflowing(track)) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScroll = track.scrollLeft;
      dragged = false;
      track.addEventListener('pointermove', onPointerMove);
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
    });

    track.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );

    track.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });

    resetScroll(track);
    if (window.requestAnimationFrame) {
      window.requestAnimationFrame(function () {
        resetScroll(track);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-cards-links]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    var root = section.querySelector('[data-cards-links]');
    if (root) initCarousel(root);
  });

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    document.querySelectorAll('[data-cards-links-track]').forEach(resetScroll);
  });
})();
